import { Injectable } from '@angular/core';

import { IndividualSettings } from './models/individual-settings';
import { Staff } from './models/staff';

@Injectable({
    providedIn: 'root'
})
export class DataService {
    private staffInfo : Staff;
    private individualSettings: IndividualSettings;
    private hasSettings: boolean;


    set setStaffInfo(val) {
        this.staffInfo = val;
    }
    get getStaffInformation() {
        return this.staffInfo;
    }

    set setStaffPermission(val) {
        this.staffInfo.access_attendance = val.access_attendance;
        this.staffInfo.access_apply = val.access_apply;
        this.staffInfo.access_omotenashi = val.access_apply;
    }

    set setIndividualSettings(val) {
        this.individualSettings = val;
    }
    get getIndividualSettings() {
        return this.individualSettings;
    }

    set setHasSettings(val) {
        this.hasSettings = val;
    }
    get getHasSettings() {
        return this.hasSettings;
    }
}